import { z } from 'zod';
import { BlockType, FieldGroupSchema, FieldRole, PlainTextFieldSchema, UrlFieldSchema } from './Types';

export enum EmbeddedSnippetLayout {
  Standard = 'standard',
}

export const EmbeddedSnippetSnippetFieldSchema = UrlFieldSchema.extend({
  name: z.literal('embeddedSnippet'),
  role: z.literal(FieldRole.EmbeddedSnippet),
});
export const EmbeddedSnippetHeaderFieldSchema = PlainTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

export type EmbeddedSnippetSnippetField = z.infer<typeof EmbeddedSnippetSnippetFieldSchema>;
export type EmbeddedSnippetHeaderField = z.infer<typeof EmbeddedSnippetHeaderFieldSchema>;
export const EmbeddedSnippetFieldSchema = z.discriminatedUnion('name', [
  EmbeddedSnippetSnippetFieldSchema,
  EmbeddedSnippetHeaderFieldSchema,
]);
export type EmbeddedSnippetField = z.infer<typeof EmbeddedSnippetFieldSchema>;

export const EmbeddedSnippetFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(EmbeddedSnippetFieldSchema),
});

export const EmbeddedSnippetBlockConfigSchema = z.object({
  options: z.record(z.string(), z.any()),
  type: z.literal(BlockType.EmbeddedSnippet),
  fieldGroups: z.tuple([EmbeddedSnippetFieldGroupSchema]),
  version: z.literal(1),
});

export const EmbeddedSnippetFieldsSchema = z.object({
  embeddedSnippet: EmbeddedSnippetFieldSchema.optional(),
  header: EmbeddedSnippetFieldSchema.optional(),
});

export type EmbeddedSnippetFieldGroup = z.infer<typeof EmbeddedSnippetFieldGroupSchema>;
export type EmbeddedSnippetFields = z.infer<typeof EmbeddedSnippetFieldsSchema>;
